"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTextInput = _interopRequireDefault(require("react-text-input"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propValidators = require("prop-validators");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var STYLES = {
  errorMessage: {
    WebkitTransition: 'all 0.25s ease-in-out',
    MozTransition: 'all 0.25s ease-in-out',
    msTransition: 'all 0.25s ease-in-out',
    OTransition: 'all 0.25s ease-in-out',
    transition: 'all 0.25s ease-in-out'
  }
};

var CardSecurityCode =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CardSecurityCode, _React$Component);

  function CardSecurityCode() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CardSecurityCode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CardSecurityCode)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: '',
      showIsRequiredError: false
      /**
       * Handle changing the csc
       * @param {String} securityCode - the csc
       * @return {String} securityCode - numbers only
       */

    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeSecurityCode", function (_ref) {
      var securityCode = _ref.target.value;
      securityCode = securityCode.replace(/\D+/g, '');

      _this.setState({
        value: securityCode
      });

      _this.handleCheckForValue(securityCode);

      _this.props.handleChangeSecurityCode(securityCode);

      return securityCode;
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckForValue", function (securityCode) {
      var cscSpecs = _this.props.cardSpec.fields.csc;
      var isRequired = cscSpecs.required;

      _this.setState({
        showIsRequiredError: isRequired && !securityCode
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (securityCode) {
      _this.props.handleFocus(securityCode);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (_ref2) {
      var securityCode = _ref2.target.value;

      _this.handleCheckForValue(securityCode);

      _this.props.handleBlur(securityCode);
    });

    return _this;
  }

  _createClass(CardSecurityCode, [{
    key: "render",
    value: function render() {
      var cscSpecs = this.props.cardSpec.fields.csc;
      var helpText = '●'.repeat(cscSpecs.maxlength);
      var errorMessage = this.props.errorMessage;
      var errorStyles = {
        height: 0,
        padding: 0
      };

      if (errorMessage) {
        errorStyles = {
          height: '100%'
        };
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)({
          'vx_has-error-with-message': errorMessage,
          'vx_has-error': !errorMessage && this.state.showIsRequiredError
        }),
        style: {
          margin: '10px 0 0',
          position: 'relative'
        }
      }, _react.default.createElement(_reactTextInput.default, {
        type: "tel",
        id: "securityCode",
        name: "securityCode",
        className: "vx_form-control vx_form-control_complex",
        value: this.state.value,
        label: this.props.label,
        helpText: helpText,
        maxLength: cscSpecs.maxlength,
        pattern: cscSpecs.pattern,
        required: cscSpecs.required,
        onChange: this.handleChangeSecurityCode,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        dir: this.props.dir
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)({
          'vx_form-control-message': errorMessage
        }),
        style: _objectSpread({}, STYLES.errorMessage, {
          errorStyles: errorStyles
        })
      }, errorMessage));
    }
  }]);

  return CardSecurityCode;
}(_react.default.Component);

_defineProperty(CardSecurityCode, "propTypes", {
  cardSpec: _propValidators.cardSpecPropType,
  label: _propTypes.default.string.isRequired,
  errorMessage: _propTypes.default.string,
  handleChangeSecurityCode: _propTypes.default.func.isRequired,
  handleFocus: _propTypes.default.func,
  handleBlur: _propTypes.default.func,
  dir: _propTypes.default.string
});

_defineProperty(CardSecurityCode, "defaultProps", {
  handleFocus: function handleFocus() {},
  handleBlur: function handleBlur() {}
});

var _default = CardSecurityCode;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-card-security-code/dist/index.js
// module id = 531
// module chunks = 5